/* eslint-disable react/jsx-props-no-spreading */
import {
    FunctionComponent, SVGProps,
} from 'react'
import {
    Grid,
} from '@mui/material'
import {
    Link,
} from 'app/MainMenu/MainMenu.types'

import CardDashboard from 'app/shared-components/CardDashboard'
import breakpoints from 'app/common/Dashboard/config/breakpoints'
import Layer from 'app/common/Dashboard/components/Layer'
import Header from 'app/common/Dashboard/components/Header'
import SmallContent from 'app/common/Dashboard/components/SmallContent'

import useStyles from './DashboardWidget.style'

const defaultProps = {
    'data-testid': '',
    className: '',
    icon: () => {
        return ''
    },
}

export default function DashboardWidget({
    className,
    title,
    subTitleText,
    links,
    icon: Icon,
    ...rest
}: {
    title: string,
    id: string,
    subTitleText: string,
    icon?: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string; }>,
    className?: string,
    links: Link[],
    'data-testid'?: string
}) {
    const {
        classes, cx,
    } = useStyles()

    if (links.length === 0) {
        return null
    }

    return (
        <Grid
            data-testid={rest['data-testid']}
            size={breakpoints}
        >
            <CardDashboard
                className={cx(className, classes.cardBody)}
                header={(
                    <Header>
                        <Icon className={classes.icon} />
                    </Header>
                )}
                smallContent={(
                    <SmallContent
                        title={title}
                        text={subTitleText}
                    />
                )}
                layer={(
                    <Layer
                        layerButtons={links}
                        layerClasses={cx({
                            [classes.column]: links.length <= 3,
                            [classes.tight]: links.length > 8,
                        })}
                    />
                )}
            />
        </Grid>
    )
}

DashboardWidget.defaultProps = defaultProps
